import { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router";
import { PasscodeForm } from "@/components/auth/PasscodeForm";
import { useAuth } from "@/hooks/useAuth";

export function AdminPasscodeEntry() {
  const { jwt } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setAuth } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (passcode: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`/api/admin/${jwt}/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ passcode }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);

      setAuth({
        role: "admin",
        jwt: jwt!,
        passcode,
        user: data.admin,
      });

      const redirect = searchParams.get("redirect");
      navigate(redirect || `/admin/${jwt}/dashboard`);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PasscodeForm
      mode="enter"
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
    />
  );
}
